import Swal, { SweetAlertIcon, SweetAlertOptions } from 'sweetalert2';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class SwalAlertService {
  constructor(private router: Router) {}

  showAlert(
    title: string,
    text: string,
    icon: SweetAlertIcon,
    showConfirmButton: boolean = false,
    showCancelButton: boolean = false,
    customOptions?: SweetAlertOptions,
    onConfirm?: () => void
  ): void {
    Swal.fire({
      title,
      text,
      icon,
      confirmButtonText: 'Ok',
      confirmButtonColor: 'green',
      cancelButtonText: 'Não',
      cancelButtonColor: 'red',
      showConfirmButton,
      showCancelButton,
      ...customOptions
    }).then(result => {
      if (result.isConfirmed && onConfirm) {
        onConfirm();
      }
    });
  }

  showAlertOnConfirmNavigate(
    title: string,
    text: string,
    icon: SweetAlertIcon,
    route: string,
    showConfirmButton: boolean = false,
    customOptions?: SweetAlertOptions
  ): void {
    Swal.fire({
      title,
      text,
      icon,
      confirmButtonText: 'Ok',
      confirmButtonColor: 'green',
      cancelButtonText: 'Não',
      cancelButtonColor: 'red',
      showConfirmButton,
      ...customOptions
    }).then(result => {
      if (result.isConfirmed) {
        this.router.navigate([route]);
      }
    });
  }
}
